import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { IconRaiseHand } from '../../../base/icons/svg';
import { open as openParticipantsPane } from '../../../participants-pane/actions.web';
import InfoRoom from './InfoRoom';
import LayoutButton from './LayoutButton';
import { countCascadeRaiseHands } from '../../../raisehand-moderation/functions';
const useStyles = makeStyles()(theme => {
    return {
        roomActionsContainer: {
            display: 'flex',
            columnGap: '32px',
            marginRight: '20px',
            alignItems: 'center'
        },
        raiseCount: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px',
            height: '28px',
            width: '56px',
            borderRadius: '6px',
            backgroundColor: theme.palette.backgroundRaisehand,
            color: theme.palette.default00,
            fontWeight: 600,
            fontSize: '16px',
            cursor: 'pointer',
            '&:hover': {
                opacity: 0.75
            },
            '& svg': {
                width: '20px',
                height: '20px',
                '& path': {
                    fill: theme.palette.default00
                }
            }
        }
    };
});
const RoomActions = () => {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    const raisedHandsCount = useSelector((state) => (state['features/base/participants'].raisedHandsQueue || []).length + (countCascadeRaiseHands(state) || 0));
    const handleOpenParticipantsPane = () => {
        dispatch(openParticipantsPane());
    };
    return (React.createElement("div", { className: classes.roomActionsContainer },
        Boolean(raisedHandsCount) &&
            React.createElement("div", { className: classes.raiseCount, onClick: handleOpenParticipantsPane },
                React.createElement(IconRaiseHand, null),
                React.createElement("span", null, raisedHandsCount)),
        React.createElement(InfoRoom, null),
        React.createElement(LayoutButton, null)));
};
export default RoomActions;
